import React, { useState } from "react";
import { ErrorMessage, Formik, Form, Field } from "formik";
import {
  Button,
  Checkbox,
  DialogActions,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
} from "@mui/material";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import * as Yup from "yup";

const SaleReturn = ({ setSaleReturnStatus }) => {
  const swal = useSwalWrapper();
  const [bill, setBill] = useState([]);
  const [rows, setRows] = useState([]);
  const [trNo, setTrNo] = useState();
  const [formval, setFormval] = useState({
    trno: "",
    FL_STONE_ID: [],
    date: "",
  });

  const validationSchema = Yup.object().shape({
    trno: Yup.string().required("Bill no is required"),
    date: Yup.string().required("Date is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    let payload = {
      trno: trNo,
      type: "35",
      purchaseDate: values?.date,
      data: bill?.filter((i) => i?.checked === true),
    };

    await jwtAuthAxios
      .post("transation/salesreturn", payload)
      .then((res) => {
        if (res.data?.status == "success") {
          setRows(res.data?.data?.det);
          setSaleReturnStatus(false);
          swal.fire({
            icon: "success",
            text: res.data.message,
          });
        } else {
          swal.fire({
            icon: "error",
            text: res.data.message,
          });
        }
      })
      .catch(() => {
        swal.fire({
          icon: "error",
          text: "something Went Wrong",
        });
      });
    setSubmitting(false);
  };

  const handleBlur = async (e) => {
    e.preventDefault();
    setTrNo(e.target.value);
    let payload = {
      trno: e.target.value,
      trtype: "35",
    };

    await jwtAuthAxios
      .post("transation/transactionDetailsforupdate", payload)
      .then((res) => {
        if (res.data?.status == "success") {
          setBill(res?.data?.data?.det);
        } else {
          swal.fire({
            icon: "error",
            text: res.data.message,
          });
        }
      })
      .catch(() => {
        swal.fire({
          icon: "error",
          text: "something Went Wrong",
        });
      });
  };

  const handleCheckboxChange = (FL_STONE_ID) => {
    setBill((prevItems) =>
      prevItems.map((item) =>
        item.FL_STONE_ID === FL_STONE_ID
          ? { ...item, checked: !item.checked }
          : item
      )
    );
  };
  const handleCancel = (setValues, setFieldValue) => {
    setBill([]);
    setValues([]);
    setTrNo("");
    setFieldValue("trno", "");
    setFieldValue("FL_STONE_ID", []);
    setFieldValue("date", "");
    setSaleReturnStatus(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Tab") {
      handleBlur(e);
    }
  };
  return (
    <div>
      <div>
        <Formik
          initialValues={formval}
          validationSchema={validationSchema}
          onSubmit={async (values, { setSubmitting }) => {
            await handleSubmit(values, { setSubmitting });
          }}
        >
          {({ values, setValues, isSubmitting, setFieldValue }) => {
            return (
              <Form>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    padding: "15px 0 0 0",
                  }}
                >
                  <Grid item xs={12} lg={12}>
                    <Field
                      name="trno"
                      as={TextField}
                      sx={{ marginBottom: "2px" }}
                      label="Bill NO"
                      fullWidth
                      value={values?.trno || ""}
                      variant="outlined"
                      onBlur={handleBlur}
                      onKeyDown={handleKeyPress} //
                      //disabled={bill?.length > 0}
                    />
                    <ErrorMessage
                      name="trno"
                      component="div"
                      className="error"
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <FormGroup>
                      <FormControlLabel
                        sx={{
                          justifyContent: "space-between",
                          fontWeight: "bold",
                          width: "100%",
                          marginLeft: "0px",
                          // padding: "20px 10px 0 0",
                        // padding: "10px 45px",
                        }}
                        control={<>ACTION</>}
                        label={
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginLeft: "0"
                            }}
                          >
                            <div style={{ minWidth: "5rem", fontWeight: "bold" }}>
                              STONEID
                            </div>
                            <div style={{ minWidth: "5rem", fontWeight: "bold" }}>
                              SHAPE
                            </div>
                            <div style={{ minWidth: "5rem", fontWeight: "bold" }}>
                              CARATS
                            </div>
                            <div style={{ minWidth: "5rem", fontWeight: "bold" }}>
                              COLOR
                            </div>
                            <div style={{ minWidth: "5rem", fontWeight: "bold" }}>
                              CLARITY
                            </div>
                          </div>
                        }
                        labelPlacement="start"
                      />
                      {bill?.map((item) => (
                        <FormControlLabel
                          sx={{ justifyContent: "space-between", marginLeft: "0" }}
                          key={item?.FL_STONE_ID}
                          control={
                            <Checkbox
                              checked={item?.checked || false}
                              onChange={() => {
                                handleCheckboxChange(item?.FL_STONE_ID);
                              }}
                            />
                          }
                          label={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginLeft: "0"
                              }}
                            >
                              <div style={{ minWidth: "5rem" }}>
                                {item?.FL_STONE_ID}
                              </div>
                              <div style={{ minWidth: "5rem" }}>
                                {item?.FL_SHAPE}
                              </div>
                              <div style={{ minWidth: "5rem" }}>
                                {item?.FL_CARATS}
                              </div>
                              <div style={{ minWidth: "5rem" }}>
                                {item?.FL_COLOR}
                              </div>
                              <div style={{ minWidth: "5rem" }}>
                                {item?.FL_CLARITY}
                              </div>
                            </div>
                          }
                          labelPlacement="start"
                        />
                      ))}
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <Field
                      name="date"
                      as={TextField}
                      fullWidth
                      sx={{ marginBottom: "2px" }}
                      type="date"
                      label="Date"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                    <ErrorMessage
                      sx={{ paddingTop: 0 }}
                      name="date"
                      component="div"
                      className="error"
                    />
                  </Grid>
                </Grid>
                <DialogActions
                  sx={{ marginLeft: "auto", padding: 0, marginTop: "30px" }}
                >
                  <Button
                    type="button"
                    color="primary"
                    variant="contained"
                    onClick={() => {
                      handleCancel(setValues, setFieldValue);
                    }}
                  >
                    cancel
                  </Button>
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    disabled={isSubmitting}
                    //onClick={handleReturn}
                  >
                    Return
                  </Button>
                </DialogActions>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

// SaleReturn.Modulename = "expensepayment";

export default SaleReturn;
